import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild, TemplateRef, ViewEncapsulation, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
    NgFlowchartCanvasDirective,
    NgFlowchartStepRegistry,
    NgFlowchart,
    NgFlowchartStepComponent
  } from '@joelwenzel/ng-flowchart';
import { InteractService } from 'app/BaseFramework';

@Component({
    selector: 'app-action-step',
    templateUrl: './action-step.component.html',
    providers: [DatePipe],
    encapsulation: ViewEncapsulation.None
})
export class ActionStepComponent extends NgFlowchartStepComponent implements OnInit {

    stepName:any = 'Action'
    eventType = ['Adjudication', 'Underwriting', 'Computation'
    , 'Correspondence', 'Eligibility', 'Payout',
    'Validation', 'Requirement', 'Custom']
    eventName = ['Gender Validation Rule', 'Age Validation Rule']
    dataSet = [ {}];

    @ViewChild('canvasContent') canvasContent: ElementRef

    ngOnInit(){
      this.stepName = this.data.name
      this.dataSet = this.data.workflowEventMapping
      console.log(this.canvasContent);
      
    }

    constructor(public interactService: InteractService){
      super();
      
    }

    _currentComponentName = 'actionStep'

    title = 'workspace';

    getDropPositionsForStep(pendingStep: NgFlowchart.PendingStep): NgFlowchart.DropPosition[] {
      // if (pendingStep.template !== ActionStepComponent) {
        return ['ABOVE', 'LEFT', 'RIGHT', 'BELOW'];
      // }
      // else {
      //   return ['BELOW'];
      // }    
    }

    checkData(data){
      console.log(data);
      
    }
  
    // Modal Methods
    isVisible = false;
  isOkLoading = false;

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(data): void {
    this.data.name = this.stepName
    if(data.name !== 'Action'){
      this.interactService.broadcast({
        actionPerformed:'ActionChanged',
        guid:this.data.guid,
      })
    }
    this.isOkLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isOkLoading = false;
    }, 500);
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  deleteStep(id?){
    this.interactService.broadcast({
      actionPerformed:'Delete',
      id:this.id
    })
  }

  addWorkflowMapping() {
    this.data.workflowEventMapping.push({
      eventType: "",
      eventName: ""
    })
  }

  removeMapping(index){
    this.data.workflowEventMapping.splice(1,index)
  }

}